// Fields for search booking record

const fields = [
  "number",
  "contact",
  "channel.name",
  "booking_date",
  "meal_plan.name",
  "company.rec_name",
  "party.name",
  "lines.room.name",
  "lines.room.accommodation.name",
  "lines.room.type_.max_accommodation",
  "lines.product.template.name",
  "lines.arrival_date",
  "lines.departure_date",
  "lines.nights_quantity",
  "lines.guests",
  "lines.guests.name",
  "lines.pax",
  "lines.nights_quantity",
  "lines.product.template.images.image_url",
  "lines.check_in_time",
];

export default fields;
